import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

//primeng component
import { InputTextModule } from 'primeng/inputtext';
import { SidebarModule } from 'primeng/sidebar';
import { BadgeModule } from 'primeng/badge';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InputSwitchModule } from 'primeng/inputswitch';
import { RippleModule } from 'primeng/ripple';
import { DropdownModule } from 'primeng/dropdown';
import { SelectButtonModule } from 'primeng/selectbutton';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { TableModule } from 'primeng/table';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { MultiSelectModule } from 'primeng/multiselect';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { CalendarModule } from 'primeng/calendar';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { PasswordModule } from 'primeng/password';
import { ChipModule } from 'primeng/chip';
import { FieldsetModule } from 'primeng/fieldset';
import { CardModule } from 'primeng/card';
import { TooltipModule } from 'primeng/tooltip';
import { ImageModule } from 'primeng/image';
import { MenuModule } from 'primeng/menu';
import { PaginatorModule } from 'primeng/paginator';
import { DialogModule } from 'primeng/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RatingModule } from 'primeng/rating';
import { SliderModule } from 'primeng/slider';
import { ProgressBarModule } from 'primeng/progressbar';
import { FileUploadModule } from 'primeng/fileupload';
import { DividerModule } from 'primeng/divider';
import { TreeTableModule } from 'primeng/treetable';
import { AccordionModule } from 'primeng/accordion';
import { TabViewModule } from 'primeng/tabview';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { PanelModule } from 'primeng/panel';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { TagModule } from 'primeng/tag';
import { EditorModule } from 'primeng/editor';
import { ImageUploadComponent } from './image-upload/image-upload.component';
import { StatusTagPipe } from '../pipes/status-tag.pipe';
import { TruncatePipe } from '../pipes/truncate.pipe';
import { CodeInputModule } from 'angular-code-input';
import { CountdownModule } from 'ngx-countdown';
import { ChipsModule } from 'primeng/chips';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { SvgUploadComponent } from './svg-file-upload/svg-file-upload.component';

@NgModule({
  declarations: [ImageUploadComponent, StatusTagPipe, TruncatePipe,SvgUploadComponent],
  imports: [
    InputGroupAddonModule,
    CommonModule,
    InputTextModule,
    SidebarModule,
    BadgeModule,
    RadioButtonModule,
    InputSwitchModule,
    RippleModule,
    DropdownModule,
    SelectButtonModule,
    ButtonModule,
    CheckboxModule,
    TableModule,
    ConfirmDialogModule,
    MultiSelectModule,
    OverlayPanelModule,
    CalendarModule,
    ToggleButtonModule,
    PasswordModule,
    ChipModule,
    FieldsetModule,
    CardModule,
    TooltipModule,
    ImageModule,
    MenuModule,
    PaginatorModule,
    DialogModule,
    SliderModule,
    ProgressBarModule,
    RatingModule,
    FormsModule,
    ConfirmDialogModule,
    ReactiveFormsModule,
    FileUploadModule,
    DividerModule,
    TreeTableModule,
    AccordionModule,
    TabViewModule,
    PanelModule,
    BreadcrumbModule,
    ProgressSpinnerModule,
    InputGroupModule,
    TagModule,
    EditorModule,
    ChipsModule,
    AutoCompleteModule
  ],
  exports: [
    InputGroupModule,
    InputGroupAddonModule,
    InputTextModule,
    SidebarModule,
    BadgeModule,
    RadioButtonModule,
    InputSwitchModule,
    RippleModule,
    DropdownModule,
    SelectButtonModule,
    ButtonModule,
    CheckboxModule,
    TableModule,
    ConfirmDialogModule,
    MultiSelectModule,
    OverlayPanelModule,
    CalendarModule,
    ToastModule,
    ToggleButtonModule,
    PasswordModule,
    ChipModule,
    FieldsetModule,
    CardModule,
    TooltipModule,
    ImageModule,
    MenuModule,
    PaginatorModule,
    DialogModule,
    FormsModule,
    RatingModule,
    SliderModule,
    RippleModule,
    ProgressBarModule,
    ConfirmDialogModule,
    ReactiveFormsModule,
    FileUploadModule,
    DividerModule,
    TreeTableModule,
    AccordionModule,
    TabViewModule,
    PanelModule,
    BreadcrumbModule,
    ProgressSpinnerModule,
    TagModule,
    EditorModule,
    ImageUploadComponent,
    StatusTagPipe,
    TruncatePipe,
    CodeInputModule,
    CountdownModule,
    ChipsModule,
    AutoCompleteModule,
    SvgUploadComponent
  ],
})
export class UIComponentModule {}
